// Caption over an option's inputs, in kore's form-label style (Form.Label's
// labelVariants) so it reads like every Field label on the page.
export const OPTION_CAPTION = "text-kore-sm font-medium leading-normal text-kore-text-muted";
